let getSenderRecipientTypeLabel = function (type) {
  let typeLabel = '';
  if (type === 'supplier') {
    typeLabel = 'Поставщик'
  } else if  (type === 'customer') {
    typeLabel = 'Покупатель'
  } else if (type==='store') {
    typeLabel = 'Магазин'
  }
  return typeLabel;
};

let getRouteNameBySenderRecipientType = function (type) {
  let routeName = '';
  if (type === 'supplier') {
    routeName = 'supplier_detail'
  } else if  (type === 'customer') {
    routeName = 'customer_detail'
  } else if (type==='store') {
    routeName = 'store_detail'
  }
  return routeName;
};


export {
  getSenderRecipientTypeLabel,
  getRouteNameBySenderRecipientType
};



// WEBPACK FOOTER //
// ./src/apps/product_order/func.js